import React, { useEffect } from 'react'
import {Link} from 'react-router-dom'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from 'react-helmet'

const Initiatives = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        pauseOnHover: true,
        arrows : false

      };
      window.scrollTo(0, 0);
      useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    return (
        <React.Fragment>
            <Helmet>
                <title> First Pakistan Global </title>
            </Helmet>
            <Header />                 
            <div className="fs-ss-20 text-dark text-center my-md-5 my-4 fw-500">
                Coming Soon!
            </div>       
            <Footer />
        </React.Fragment>
    )
}

export default Initiatives
